import { render, staticRenderFns } from "./ServeCount.vue?vue&type=template&id=0d5d2036&"
import script from "./ServeCount.vue?vue&type=script&lang=js&"
export * from "./ServeCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports